setTimeout(function() {
  $('.alert-success, .label-warning').fadeOut('fast');
}, 3000);
$(document).ready(function () {
  if ($('.alert.alert-alert.mt-10').text() == '既にログインしています。') {
    $('.alert.alert-alert.mt-10').addClass('alert-success').removeClass('alert-alert')
  }
});
